import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Project } from 'src/app/model/project/project';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { ClientCornerMapRequestHelper } from './client-corner-map-request-helper';
import { Observable } from 'rxjs';
import { _get } from '../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ClientCornerMapAddressSearchControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as Project[];
  constructor(
    http: HttpClient,
    private snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/projects/client-map', requestServices);
  }

  public async clientMapProjectsForAddress(
    companyId: number,
    addressLine1: string,
    addressPostalCode: string
  ): Promise<Project[]> {
    const hasAddressLine1 = !StringHelper.isEmpty(addressLine1);
    const hasAddressPostalCode = !StringHelper.isEmpty(addressPostalCode);
    const params =
      hasAddressLine1 && hasAddressPostalCode
        ? `?addressLine1=${addressLine1}&addressPostalCode=${addressPostalCode}`
        : hasAddressLine1
        ? `?addressLine1=${addressLine1}`
        : hasAddressPostalCode
        ? `?addressPostalCode=${addressPostalCode}`
        : '';
    const path = `/${companyId}${params}`;
    const projects = await this.get(path, this.deserialize).toPromise();

    ClientCornerMapRequestHelper.processProjects(projects);
    if (!CollectionHelper.isPopulated(projects)) {
      this.snackService.showWarning('Geen opdrachten gevonden');
    }
    return projects;
  }
}
